module.exports = __webpack_public_path__ + "img/curacao.ca9fb97b.svg";